import { ICellRendererParams } from 'ag-grid-enterprise';
import React from 'react';
import { CurrencyText } from '../input-formatters/CurrencyText';
import { NumericFormat } from 'react-number-format';

export const AgGridCurrencyCell = ({
  value,
  showEmptyAsDash = false
}: ICellRendererParams & {
  showEmptyAsDash?: boolean;
}) => {
  if (showEmptyAsDash && (value == null || value === 0 || Number.isNaN(value))) {
    return <>–</>;
  }
  if (Number.isNaN(value) || typeof value === 'undefined' || value === null) {
    return;
  }
  return <CurrencyText value={value} />;
};

export const FactorCell = ({ value }: ICellRendererParams) => {
  return <NumericFormat value={Number(value)} displayType="text" decimalScale={5} thousandSeparator />;
};

export const NumberCell = ({ value }: ICellRendererParams) => {
  return <NumericFormat value={value} displayType="text" decimalScale={2} thousandSeparator />;
};
